module.exports = {
      id: "ic-hollow-grayscale-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#ic-hollow-grayscale-usage",
      toString: function () {
        return this.url;
      }
    }